var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlaylistActivityHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8744 1.48726C11.8744 0.168411 13.441 -0.464714 14.3596 0.389655L14.499 0.537033L24.3943 12.4114L22.1138 14.3119L14.843 5.58789L14.843 35.1312L14.843 35.3254H14.8405C14.7376 39.3344 11.4554 42.5527 7.4215 42.5527C3.32272 42.5527 0 39.23 0 35.1312C0 31.0324 3.32272 27.7097 7.4215 27.7097C9.09224 27.7097 10.634 28.2618 11.8744 29.1935V1.48726ZM7.42154 39.5841C9.87452 39.5841 11.8642 37.6007 11.8744 35.1501V35.1124C11.8642 32.6618 9.87452 30.6783 7.42154 30.6783C4.96227 30.6783 2.96864 32.672 2.96864 35.1312C2.96864 37.5905 4.96227 39.5841 7.42154 39.5841ZM40.4298 17.6435L39.4145 14.854L19.8875 21.9612L20.9028 24.7508L40.4298 17.6435ZM39.4145 22.7702L40.4298 25.5598L20.9028 32.667L19.8875 29.8775L39.4145 22.7702ZM40.4298 33.4761L39.4145 30.6865L19.8875 37.7937L20.9028 40.5833L40.4298 33.4761Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaylistActivityHeader);
export default __webpack_public_path__ + "static/media/icon-playlist-activity-header.291bc9cf.svg";
export { ForwardRef as ReactComponent };